var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5EBAE7"
    },
    points: "504.194,370.714 304.037,370.714 256,410.745 215.969,370.714 7.805,370.714 7.805,98.5  504.194,98.5 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#36A9E1"
    },
    points: "504.194,98.5 504.194,370.714 304.037,370.714 256,410.745 215.969,370.714 7.805,370.714  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D1D1B"
    },
    d: "M255.521,421.304l-42.786-42.786H0V90.696h512v287.823H306.864L255.521,421.304z M15.609,362.909 h203.592l37.278,37.278l44.733-37.278h195.179V106.305H15.609V362.909z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.842,
    y: 146.737,
    style: {
      fill: "#FFFFFF"
    },
    width: 184.147,
    height: 15.609
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 55.842,
    y: 186.769,
    style: {
      fill: "#1D1D1B"
    },
    width: 24.017,
    height: 15.609
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.842,
    y: 226.801,
    style: {
      fill: "#1D1D1B"
    },
    width: 176.134,
    height: 15.609
  })), /*#__PURE__*/React.createElement("rect", {
    x: 247.988,
    y: 226.801,
    style: {
      fill: "#FFFFFF"
    },
    width: 128.099,
    height: 15.609
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 392.103,
    y: 226.801,
    style: {
      fill: "#1D1D1B"
    },
    width: 48.035,
    height: 15.609
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.842,
    y: 266.834,
    style: {
      fill: "#1D1D1B"
    },
    width: 384.298,
    height: 15.609
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.842,
    y: 306.866,
    style: {
      fill: "#1D1D1B"
    },
    width: 40.031,
    height: 15.609
  })), /*#__PURE__*/React.createElement("rect", {
    x: 111.887,
    y: 306.866,
    style: {
      fill: "#FFFFFF"
    },
    width: 184.147,
    height: 15.609
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.048,
    y: 306.866,
    style: {
      fill: "#1D1D1B"
    },
    width: 128.099,
    height: 15.609
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 352.07,
    y: 122.719,
    style: {
      fill: "#FFFFFF"
    },
    width: 16.013,
    height: 15.609
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.1,
    y: 122.719,
    style: {
      fill: "#FFFFFF"
    },
    width: 16.013,
    height: 15.609
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.13,
    y: 122.719,
    style: {
      fill: "#FFFFFF"
    },
    width: 16.012,
    height: 15.609
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.15,
    y: 122.719,
    style: {
      fill: "#FFFFFF"
    },
    width: 16.014,
    height: 15.609
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.64d5ee371e6532d07f5ce4ece038ab6c.svg";
export { ForwardRef as ReactComponent };